import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MainComponent from "./components/MainComponent";
import PrintQuestionPaper from "./components/PrintQuestionPaper";

function App() {
  const [printContent, setPrintContent] = useState("");
  return (
    <Routes>
      <Route path="/" element={<MainComponent setPrintContent={setPrintContent} />} />
      <Route path="/print-question-paper" element={<PrintQuestionPaper printContent={printContent} />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
